import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { FileUploader, FileItem } from 'ng2-file-upload';

import { ContributorService } from './../../../services/contributor.service';
import { AppComponent } from './../../../app.component';
import { Contributor } from '../../../models/Contributor';

import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-contributor-form',
  templateUrl: './contributor-form.component.html',
  styleUrls: ['./contributor-form.component.css'],
  providers: [ContributorService]
})
export class ContributorFormComponent implements OnInit {
  wmodel: Contributor = new Contributor();
  dirty: boolean;
  loading: boolean;
  @ViewChild('f') form: FormGroup;

  photopath: string;
  public uploader: FileUploader = new FileUploader({ url: environment.server.url + '/contributor/upload-image' });


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contributorService: ContributorService,
    public parent: AppComponent) {   }

  persist() {
    let that = this;
    that.loading = true;
    that.parent.addToast('', 'salvataggio in corso...', ((wid) => {
      setTimeout(function() {
        that.contributorService.persist(that.wmodel).subscribe((res) => {
          console.log(res)

          if (res.success && res.contributor) {
            that.wmodel = res.contributor;
          }

          that.parent.clearToast(wid);
          that.loading = false;
          that.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
        })
      }, 2000);
    }))
  }

  onNotifyCollana(o: Contributor): void {
    console.log('onNotify', o)
  }

  ngOnInit() {
    let codice = this.route.snapshot.paramMap.get('codice');
    console.log(codice);
    if (codice) {
      this.contributorService.getContributor(codice).subscribe(result => {
        console.log(result);
        this.wmodel = new Contributor(result.contributor);
        console.log(this.wmodel);
      })

      this.photopath = this.contributorService.getContributorPhotoPath(codice);
    } else {
      this.wmodel = new Contributor();
    }
  }

  getTitle(): string {
    return "contributor";
  }

  addNewBook() {
    this.router.navigate(['/contributor']);
  }

  go2search() {
    this.router.navigate(['/contributor/search']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contributor/contributor-form/contributor-form.component.ts